<template>
  <div>
    <revenue-form
      :create="create"
      :view="view"
      :change="change"
      @close="$router.push('/admin/revenue/list')"
      @list="$router.push('/admin/revenue/list')"
      @change="id=> $router.push('/admin/revenue/change?id=' + id)"
      @view="id=> $router.push('/admin/revenue/view?id=' + id)"
    />
  </div>
</template>
<script >

import RevenueForm from "@/views/admin/components/Revenue-form.vue"

export default {
  components: { RevenueForm },
  props: ['create', 'change', 'view'],
  mounted () {
    console.log('Revenue-page.vue is loaded')
  },
}
</script>

<style scoped>

</style>
